import { Button } from '@/components/ui'

import TooltipIcon from '../../../assets/icons/tooltip.svg'
import { IColumn } from '../../../core/components/Table'
import { CheckCircleIcon, XCircleIcon } from 'lucide-react'
import { Icon } from '@/common/components/Icon'

const ticketColumnSerial = (
  handleGetCheckinHistory: (ticketCode: string) => void,
  handleUpdateTicket: (ticketCode: string) => void,
  setCancelTicket: (ticketCode: string) => void,
  setShowMessageBox: (show: boolean) => void,
  permissions: boolean,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Ticket Type',
    accessor: 'ticketName',
    sortable: true,
  },
  {
    title: 'Valid (nu e anulat)',
    accessor: 'valid',
    sortable: true,
    render: (row) => (
      <span style={{ color: row.valid ? '#198754' : '#DC3545' }}>
        {row.valid ? 'YES' : 'NO'}
      </span>
    ),
  },
  {
    title: 'Cancel Reason',
    accessor: 'reason',
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <i className="bi bi-check-circle-fill text-success" />
      ) : (
        <i className="bi bi-x-circle-fill text-danger" />
      ),
  },
  {
    title: 'Event',
    accessor: 'editionName',
    sortable: true,
  },
  {
    title: '',
    accessor: '',
    render: (row) => {
      return row.ticketCode ? (
        <div className="flex gap-2">
          <Button
            className="w-full"
            variant="secondary"
            disabled={!row.valid}
            size="sm"
            onClick={() => {
              handleUpdateTicket(row.ticketCode)
            }}
          >
            Update
          </Button>
          {permissions && (
            <Button
              className="w-full"
              variant="destructive"
              disabled={!row.valid}
              size="sm"
              onClick={() => {
                setCancelTicket(row.ticketCode)
                setShowMessageBox(true)
              }}
            >
              Cancel Ticket
              <Icon
                icon="close-circle"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </Button>
          )}
        </div>
      ) : null
    },
  },
]

const ticketColumnBarcode = (
  handleGetCheckinHistory: (ticketCode: string) => void,
  handleUpdateTicket: (ticketCode: string) => void,
  setCancelTicket: (ticketCode: string) => void,
  setShowMessageBox: (show: boolean) => void,
  permissions: boolean,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Ticket Type',
    accessor: 'ticketName',
    sortable: true,
  },
  {
    title: 'Valid (nu e anulat)',
    accessor: 'valid',
    sortable: true,
    render: (row) => (
      <span className={row.valid ? 'text-accent-1' : 'text-accent-3'}>
        {row.valid ? 'YES' : 'NO'}
      </span>
    ),
  },
  {
    title: 'Cancel Reason',
    accessor: 'reason',
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <CheckCircleIcon className="w-4 h-4 text-accent-1" />
      ) : (
        <XCircleIcon className="w-4 h-4 text-accent-3" />
      ),
  },
  {
    title: 'Event',
    accessor: 'editionName',
    sortable: true,
  },
  {
    title: '',
    accessor: '',
    render: (row) => {
      return row.ticketCode ? (
        <div className="flex gap-2">
          <Button
            className="w-full"
            variant="secondary"
            size="sm"
            disabled={!row.valid}
            onClick={() => {
              handleUpdateTicket(row.ticketCode)
            }}
          >
            Update
          </Button>
          {permissions && (
            <Button
              className="w-full"
              variant="destructive"
              size="sm"
              disabled={!row.valid}
              onClick={() => {
                setCancelTicket(row.ticketCode)
                setShowMessageBox(true)
              }}
            >
              Cancel Ticket
              <Icon
                icon="close-circle"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </Button>
          )}
        </div>
      ) : null
    },
  },
]

const ticketColumnEmail = (
  handleGetCheckinHistory: (ticketCode: string) => void,
  handleUpdateTicket: (ticketCode: string) => void,
  setCancelTicket: (ticketCode: string) => void,
  setShowMessageBox: (show: boolean) => void,
  permissions: boolean,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Ticket Type',
    accessor: 'ticketName',
    sortable: true,
  },
  {
    title: 'Valid (nu e anulat)',
    accessor: 'valid',
    sortable: true,
    render: (row) => (
      <span className={row.valid ? 'text-accent-1' : 'text-accent-3'}>
        {row.valid ? 'YES' : 'NO'}
      </span>
    ),
  },
  {
    title: 'Cancel Reason',
    accessor: 'reason',
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <CheckCircleIcon className="w-4 h-4 text-accent-1" />
      ) : (
        <XCircleIcon className="w-4 h-4 text-accent-3" />
      ),
  },
  {
    title: 'Event',
    accessor: 'editionName',
    sortable: true,
  },
  {
    title: '',
    accessor: '',
    render: (row) => {
      return row.ticketCode ? (
        <div className="flex gap-2">
          <Button
            className="w-full"
            variant="secondary"
            disabled={!row.valid}
            size="sm"
            onClick={() => {
              handleUpdateTicket(row.ticketCode)
            }}
          >
            Update
          </Button>
          {permissions && (
            <Button
              className="w-full"
              variant="destructive"
              size="sm"
              disabled={!row.valid}
              onClick={() => {
                setCancelTicket(row.ticketCode)
                setShowMessageBox(true)
              }}
            >
              Cancel Ticket
              <Icon
                icon="close-circle"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </Button>
          )}
        </div>
      ) : null
    },
  },
]

const ticketColumnTopup = (
  handleGetCheckinHistory: (ticketCode: string) => void,
  handleUpdateTicket: (ticketCode: string) => void,
  setCancelTicket: (ticketCode: string) => void,
  setShowMessageBox: (show: boolean) => void,
  permissions: boolean,
): IColumn[] => [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'ticketCode',
    sortable: true,
    render: (row) =>
      row.ticketCode && (
        <div className="flex items-center gap-2">
          <div
            className="view text-accent-1 underline cursor-pointer"
            onClick={async () => {
              handleGetCheckinHistory(row.ticketCode)
            }}
          >
            <img src={TooltipIcon} alt="" />
          </div>
          <span>{row.ticketCode}</span>
        </div>
      ),
  },
  {
    title: 'Ticket Type',
    accessor: 'ticketName',
    sortable: true,
  },
  {
    title: 'Valid (nu e anulat)',
    accessor: 'valid',
    sortable: true,
    render: (row) => (
      <span className={row.valid ? 'text-accent-1' : 'text-accent-3'}>
        {row.valid ? 'YES' : 'NO'}
      </span>
    ),
  },
  {
    title: 'Anytime',
    accessor: 'anytime',
    sortable: true,
    render: (row) => (
      <span className={row.anytime ? 'text-accent-1' : 'text-accent-3'}>
        {row.anytime ? 'YES' : 'NO'}
      </span>
    ),
  },
  {
    title: 'Cancel Reason',
    accessor: 'reason',
    sortable: true,
  },
  {
    title: 'Backstage Synced',
    accessor: 'backstageSynced',
    sortable: true,
    render: (row) =>
      row.backstageSynced ? (
        <CheckCircleIcon className="w-4 h-4 text-accent-1" />
      ) : (
        <XCircleIcon className="w-4 h-4 text-accent-3" />
      ),
  },
  {
    title: 'Event',
    accessor: 'editionName',
    sortable: true,
  },
  {
    title: '',
    accessor: '',
    render: (row) => {
      return row.ticketCode ? (
        <div className="flex gap-2">
          <Button
            className="w-full"
            variant="secondary"
            disabled={!row.valid}
            size="sm"
            onClick={() => {
              handleUpdateTicket(row.ticketCode)
            }}
          >
            Update
          </Button>
          {permissions && (
            <Button
              className="w-full"
              variant="destructive"
              disabled={!row.valid}
              size="sm"
              onClick={() => {
                setCancelTicket(row.ticketCode)
                setShowMessageBox(true)
              }}
            >
              Cancel Ticket
              <Icon
                icon="close-circle"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </Button>
          )}
        </div>
      ) : null
    },
  },
]

export const getTicketColumn = (
  searchBy: 'serial' | 'barcode' | 'email' | 'topupOrder',
  handleGetCheckinHistory: (ticketCode: string) => void,
  handleUpdateTicket: (ticketCode: string) => void,
  setCancelTicket: (ticketCode: string) => void,
  setShowMessageBox: (show: boolean) => void,
  permissions: boolean,
) => {
  switch (searchBy) {
    case 'serial':
      return ticketColumnSerial(
        handleUpdateTicket,
        handleGetCheckinHistory,
        setCancelTicket,
        setShowMessageBox,
        permissions,
      )
    case 'barcode':
      return ticketColumnBarcode(
        handleUpdateTicket,
        handleGetCheckinHistory,
        setCancelTicket,
        setShowMessageBox,
        permissions,
      )
    case 'email':
      return ticketColumnEmail(
        handleUpdateTicket,
        handleGetCheckinHistory,
        setCancelTicket,
        setShowMessageBox,
        permissions,
      )
    case 'topupOrder':
      return ticketColumnTopup(
        handleUpdateTicket,
        handleGetCheckinHistory,
        setCancelTicket,
        setShowMessageBox,
        permissions,
      )
    default:
      return ticketColumnSerial(
        handleUpdateTicket,
        handleGetCheckinHistory,
        setCancelTicket,
        setShowMessageBox,
        permissions,
      )
  }
}
